// Admin routes for P6-B (SHIPPING-03/04/05/08, ORDER-06/08/09, RISK-01/03/04). Owned by that worker; the router mounts
// whatever this returns under the app shell (before the store-area placeholder), so modules never
// edit router.tsx. Paths follow IA §2.1 (Orders → Dispatch / Returns; Settings → Delivery → Courier
// accounts). Order protection is a tab of Settings → Checkout (modules/settings.tsx). Invoices and COD checks are Orders pages.
import { useEffect } from "react";
import {
  createRoute,
  useRouter,
  type AnyRoute,
  type RouteComponent,
  lazyRouteComponent,
} from "@tanstack/react-router";

// Pages are code-split: each loads when its route opens, not with the shell.
const load1 = () => import("../fulfilment/CodChecksPage");
const CodChecksPage = lazyRouteComponent(load1, "CodChecksPage");
const load2 = () => import("../fulfilment/CouriersPage");
const CouriersPage = lazyRouteComponent(load2, "CouriersPage");
const load3 = () => import("../fulfilment/ReturnsPage");
const ReturnsPage = lazyRouteComponent(load3, "ReturnsPage");

/** Removed pages (owner, 2026-10-21): Dispatch (couriers are booked with Submit to logistics and
 * each order shows its parcel) and Invoices and receipts (invoices print from the order and the
 * selection bar). Old links land on the orders list. */
function BackToOrders() {
  const router = useRouter();
  useEffect(() => {
    router.history.replace(router.state.location.pathname.replace(/\/(dispatch|invoices)\/?$/, ""));
  }, [router]);
  return null;
}

export function fulfilmentRoutes(appRoute: AnyRoute): AnyRoute[] {
  const at = (path: string, component: RouteComponent) =>
    createRoute({ getParentRoute: () => appRoute, path, component }) as unknown as AnyRoute;
  return [
    at("/$org/$store/orders/dispatch", BackToOrders),
    at("/$org/$store/orders/returns", ReturnsPage),
    at("/$org/$store/orders/invoices", BackToOrders),
    at("/$org/$store/orders/cod-checks", CodChecksPage),
    at("/$org/$store/apps/couriers", CouriersPage),
  ];
}
